var map = {
	"./bowl.mp3": [
		4213,
		213
	],
	"./close.mp3": [
		8978,
		978
	],
	"./music-1.mp3": [
		1625,
		625
	],
	"./voiceover-2.mp3": [
		8662,
		662
	],
	"./voiceover.mp3": [
		774,
		774
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4447;
module.exports = webpackAsyncContext;